export default __webpack_public_path__ + "static/media/leaf-bg.386ad8ff.jpg";